import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, Input, HostBinding, ContentChildren, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { startWith, takeUntil, delay } from 'rxjs/operators';
import { Subject } from 'rxjs';

class CardComponent {
    constructor() {
        this.size = 100;
        this.classCard = true;
        this.grouped = false;
        this.groupedFirst = false;
        this.groupedLast = false;
        this.grey = false;
        this.noMargin = false;
        this.noPadding = false;
    }
    get classes() {
        return {
            'card--200': this.size === 200,
        };
    }
}
CardComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: CardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
CardComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: CardComponent, selector: "sd-card", inputs: { size: "size", grey: "grey", noMargin: "noMargin", noPadding: "noPadding" }, host: { properties: { "class.card": "this.classCard", "class.card--is-grouped": "this.grouped", "class.card--is-grouped-first": "this.groupedFirst", "class.card--is-grouped-last": "this.groupedLast", "class.card--is-grey": "this.grey", "class": "this.classes", "class.card--no-margin": "this.noMargin", "class.card--no-padding": "this.noPadding" } }, ngImport: i0, template: "<ng-content></ng-content>\n", styles: ["@charset \"UTF-8\";.card{padding:.5rem 1rem;margin-bottom:3.5rem;background-color:var(--color-white);border-radius:1rem}.card--is-grouped{margin-bottom:2rem}.card--is-grey{background-color:var(--color-grey-100)}.card--has-border{border:solid 1px var(--color-grey-200)}@media screen and (min-width: 768px){.card--200{padding:1.25rem 2.5rem}}@media screen and (max-width: 767px){.card--is-grouped{padding-top:0;padding-bottom:0;margin-bottom:0;border-radius:0}.card--is-grouped-first{padding-top:.5rem;border-radius:1rem 1rem 0 0}.card--is-grouped-last{padding-bottom:.5rem;margin-bottom:3.5rem;border-radius:0 0 1rem 1rem}}@media screen and (max-width: 425px){.card{margin-right:-16px;margin-bottom:1.5rem;margin-left:-16px}.card--is-grouped:not(.card--is-grouped-last){margin-bottom:0}}.card--no-padding{padding:0}.card--no-margin{margin:0}sd-card{display:block}\n"], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: CardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sd-card', encapsulation: ViewEncapsulation.None, template: "<ng-content></ng-content>\n", styles: ["@charset \"UTF-8\";.card{padding:.5rem 1rem;margin-bottom:3.5rem;background-color:var(--color-white);border-radius:1rem}.card--is-grouped{margin-bottom:2rem}.card--is-grey{background-color:var(--color-grey-100)}.card--has-border{border:solid 1px var(--color-grey-200)}@media screen and (min-width: 768px){.card--200{padding:1.25rem 2.5rem}}@media screen and (max-width: 767px){.card--is-grouped{padding-top:0;padding-bottom:0;margin-bottom:0;border-radius:0}.card--is-grouped-first{padding-top:.5rem;border-radius:1rem 1rem 0 0}.card--is-grouped-last{padding-bottom:.5rem;margin-bottom:3.5rem;border-radius:0 0 1rem 1rem}}@media screen and (max-width: 425px){.card{margin-right:-16px;margin-bottom:1.5rem;margin-left:-16px}.card--is-grouped:not(.card--is-grouped-last){margin-bottom:0}}.card--no-padding{padding:0}.card--no-margin{margin:0}sd-card{display:block}\n"] }]
        }], propDecorators: { size: [{
                type: Input
            }], classCard: [{
                type: HostBinding,
                args: ['class.card']
            }], grouped: [{
                type: HostBinding,
                args: ['class.card--is-grouped']
            }], groupedFirst: [{
                type: HostBinding,
                args: ['class.card--is-grouped-first']
            }], groupedLast: [{
                type: HostBinding,
                args: ['class.card--is-grouped-last']
            }], grey: [{
                type: HostBinding,
                args: ['class.card--is-grey']
            }, {
                type: Input
            }], classes: [{
                type: HostBinding,
                args: ['class']
            }], noMargin: [{
                type: HostBinding,
                args: ['class.card--no-margin']
            }, {
                type: Input
            }], noPadding: [{
                type: HostBinding,
                args: ['class.card--no-padding']
            }, {
                type: Input
            }] } });

class CardGroupComponent {
    constructor() {
        this.$destroyed = new Subject();
    }
    ngAfterContentInit() {
        // listen to changes of the content children
        const cards$ = this.cards.changes.pipe(
        // initialize
        startWith(this.cards), 
        // auto unsubscribe when destroyed
        takeUntil(this.$destroyed), 
        // make async
        delay(1));
        cards$.subscribe(() => {
            // iterate through all cards, set grouped and set the grouped first/last attribute accordingly
            this.cards.forEach((item, index, array) => {
                item.grouped = true;
                item.groupedLast = index === array.length - 1;
                item.groupedFirst = index === 0;
            });
        });
    }
    ngOnDestroy() {
        // fire destroyed event to stop the observable (i.e. avoiding memory leaks)
        this.$destroyed.next();
    }
}
CardGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: CardGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
CardGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.2", type: CardGroupComponent, selector: "sd-card-group", queries: [{ propertyName: "cards", predicate: CardComponent }], ngImport: i0, template: "<ng-content></ng-content>\n", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: CardGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sd-card-group', template: "<ng-content></ng-content>\n", styles: [""] }]
        }], propDecorators: { cards: [{
                type: ContentChildren,
                args: [CardComponent]
            }] } });

class SmartDesignCardModule {
}
SmartDesignCardModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: SmartDesignCardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SmartDesignCardModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: SmartDesignCardModule, declarations: [CardComponent, CardGroupComponent], imports: [CommonModule], exports: [CardComponent, CardGroupComponent] });
SmartDesignCardModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: SmartDesignCardModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.2", ngImport: i0, type: SmartDesignCardModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CardComponent, CardGroupComponent],
                    imports: [CommonModule],
                    exports: [CardComponent, CardGroupComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { CardComponent, CardGroupComponent, SmartDesignCardModule };
